'use strict';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../../components/buttons/Button';
import {I18nMessage} from '../../../../components/I18nMessage';
import {FilterInput} from '../../../../components/lists/FilterInput';
import {NavigationBreadcrumb} from '../../../../components/views/NavigationBreadcrumb';
import {ViewHeader} from '../../../../components/views/ViewHeader';


export function FormsListHeaderView(props) {
  const filterComponent = (
    <FilterInput
      searchOnly={true}
      onChangeDebounce={450}
      onFilterChange={props.onFilterChange}
    />
  );

  return (
    <Fragment>
      <ViewHeader
        className="LegacyHeader"
        showBackButton={false}
      >
        <div className="ProjectLayout__header">
          <div className="ProjectLayout__headerLeft">
            <NavigationBreadcrumb
              className="ProjectLayout__breadcrumb"
              path={props.breadcrumbPath}
            />
            <div className="ProjectLayout__title">
              <I18nMessage message="forms.views.list.header.label" />
            </div>
          </div>

          <div className="ProjectLayout__desktopFilter">
            {filterComponent}
          </div>

          <div className="ProjectLayout__headerRight">
            <Button
              className="FormsListHeader__headerButton"
              iconClass="ion-ios-plus-empty"
              onClick={props.onClickCreate}
            />
          </div>
        </div>
      </ViewHeader>
      <div className="ProjectLayout__mobileFilter">
        {filterComponent}
      </div>
    </Fragment>
  );
}

FormsListHeaderView.propTypes = {
  className: T.string,
  breadcrumbPath: T.array,
  onFilterChange: T.func,
  onClickCreate: T.func,
};

FormsListHeaderView.defaultProps = {
  className: '',
  breadcrumbPath: [],
};



// WEBPACK FOOTER //
// ./src/js/forms/components/views/FormsListHeader/FormsListHeaderView.js